import { assets } from '@/assets';
import { strings } from '@/content/strings';
import { Frame } from './Frame';
import { Icon } from './Icon';
import { Surface } from './Surface';
import styles from './TransmissionMonitor.module.css';

export type ScoutPose = 'listening' | 'receiving' | 'celebrating';

interface TransmissionMonitorProps {
  pose: ScoutPose;
  /** Sends the codename without saying it (hidden once it is received). */
  onSend?: (() => void) | undefined;
  /** Hears the codename read aloud, for help reading it (hidden once it is received). */
  onHear?: (() => void) | undefined;
}

/**
 * The transmission stage's monitor (epic #44, docs/design/transmission.md, Variation A): Scout the
 * Otter at headquarters on a live channel, in the word card's place. The foe card below never
 * moves. "Hear the name" reads the codename aloud (help reading it); "send" is the way through
 * without a voice, and never earns the bonus star.
 */
export function TransmissionMonitor({ pose, onSend, onHear }: TransmissionMonitorProps) {
  const portrait = assets.characters.scout[pose];
  return (
    <Frame className={styles.frame}>
      <Surface variant="screen" className={styles.card}>
        <div className={styles.screen}>
          <span className={styles.scan} aria-hidden />
          <img
            key={pose}
            className={styles.scout}
            src={portrait.url}
            width={portrait.width}
            height={portrait.height}
            alt={strings.transmission.scout}
            draggable={false}
          />
        </div>
        <div className={styles.side}>
          <p className={styles.title}>{strings.transmission.title}</p>
          {onHear && (
            <button type="button" className={styles.send} onClick={onHear}>
              <Icon name="speaker" className={styles.icon} />
              {strings.transmission.hear}
            </button>
          )}
          {onSend && (
            <button type="button" className={styles.send} onClick={onSend}>
              {strings.transmission.send}
            </button>
          )}
        </div>
      </Surface>
    </Frame>
  );
}
